import json from "../json/featureFlagsSubscriptionLoad.json";

export default async () => JSON.parse(JSON.stringify(await json));
